"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    NullPointerException: (obj, message) => {
        return new Error('Null Pointer Exception.\n' + message);
    },
    NotAnObjectException: (obj, message) => {
        return new Error('Not An Object Exception.\n' + message);
    },
};
